export default __webpack_public_path__ + "static/media/ecologismo.22f357da.png";